import React from "react";
import { Btn } from "../../assets/styles/style";
import { NavText } from "./style";
import { useNavigate, useLocation } from "react-router-dom";

const IeltsNavTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isResultsPage = location.pathname === "/ielts-results" || location.pathname.includes("/ielts-test-details");

  if (!isResultsPage) return null;

  return (
    <Btn onClick={() => navigate("/ielts-dashboard")} style={{ width: "100%" }}>
      <NavText style={{ color: "#6B41CB" }}>Dashboard</NavText>
    </Btn>
  );
};

export default IeltsNavTabs;
